// Wersja mobilna (znika boczny panel, pojawia się dolny pasek zakładek) — to samo zapytanie co w
// stylach. Wąski ekran ALBO telefon w poziomie (dotyk, niski ekran): w poziomie telefon ma ponad
// 669 px szerokości i dostawał desktop wciśnięty w ~400 px wysokości, pomieszany z regułami mobilnymi.
// Dzięki temu obrót telefonu nie przełącza wersji.
export const MOBILE_QUERY =
  '(max-width: 669px), (pointer: coarse) and (max-height: 500px) and (max-width: 950px)';

// Paginacja na telefonie: pełny pasek (skrajne strony, licznik, wybór rozmiaru) nie mieści się
// w szerokości ekranu — zostają poprzednia/następna i numery stron (z `pageLinkSize={3}`).
export const MOBILE_PAGINATOR_TEMPLATE = 'PrevPageLink PageLinks NextPageLink';
